import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Route from 'cio/routes/base';
import { hash } from 'rsvp';
import SqlImportsImportSettingsController from 'cio/pods/sql-imports/import/settings/controller';
import Transition from '@ember/routing/-private/transition';
import SqlImportModel from 'cio/models/sql-import';
import { action } from '@ember/object';
import SqlImportDatabaseModel from 'cio/models/sql-import-database';

export default class SqlImportsImportSettings extends Route {
  @service store!: DS.Store;

  async model() {
    let sqlImport = this.modelFor('sql-imports.import') as SqlImportModel;
    let segments = await this.store.findAll('short-segment');
    let originalSegmentId = sqlImport.belongsTo('segment').id();
    let databaseType = (sqlImport.belongsTo('database').value() as SqlImportDatabaseModel | null)?.type;

    return hash({
      sqlImport,
      databases: this.store.query('sql-import-database', { type: databaseType }),
      segments: segments.filter((segment) => segment.isManual),
      originalSegment:
        originalSegmentId != null ? this.store.findRecord('segment', sqlImport.belongsTo('segment').id()) : null,
    });
  }

  setupController(
    controller: SqlImportsImportSettingsController,
    model: ReturnType<SqlImportsImportSettings['model']>,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
  }

  resetController(controller: SqlImportsImportSettingsController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);
    controller.resetModel();
  }

  @action
  willTransition(transition: Transition) {
    let { hasChangedIdFieldName, hasChangedInterval, hasChangedSegment, hasChangedImportType, hasChangedDatabase } =
      this.controller as SqlImportsImportSettingsController;
    if (hasChangedIdFieldName) {
      transition.abort();
      (this.controller as SqlImportsImportSettingsController).confirmQueryChange();
      return;
    } else if (hasChangedInterval || hasChangedSegment || hasChangedImportType || hasChangedDatabase) {
      transition.abort();
      (this.controller as SqlImportsImportSettingsController).confirmChanges(transition);
      return;
    }
  }
}
